import React, { memo } from 'react';
import type { CSSProperties } from 'react';
import type { DividerConfig } from '@segmently/schema-models/v2';
import { mapFrameLayoutStyles } from '../../../utils/styleMapper';
import styles from './Divider.module.css';

export interface DividerProps {
  divider: DividerConfig | undefined;
  className?: string;
  'data-testid'?: string;
}

export const Divider = memo(function Divider({
  divider,
  className,
  'data-testid': testId,
}: DividerProps): React.ReactElement | null {
  if (!divider) {
    return null;
  }

  const { appearance, layout } = divider;

  const layoutStyles: CSSProperties = mapFrameLayoutStyles(layout);

  const dividerStyle: CSSProperties = {
    ...(appearance?.color && { backgroundColor: appearance.color }),
    ...(appearance?.height !== undefined && { height: appearance.height }),
  };

  return (
    <div style={layoutStyles} data-testid={testId ? `${testId}-wrapper` : undefined}>
      <hr
        className={className ? `${styles.divider} ${className}` : styles.divider}
        style={dividerStyle}
        data-testid={testId}
      />
    </div>
  );
});

Divider.displayName = 'Divider';
